import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PricingPage from "@/pages/PricingPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import LandingPage from "@/pages/LandingPage";
import { VerifyEmailPage, ForgotPasswordPage, ResetPasswordPage, SetPasswordPage } from "@/pages/AuthActionPages";
import ErrorBoundary from "@/components/ErrorBoundary";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#09090b] text-[#71717a] text-sm">
    A carregar…
  </div>
);

// Public landing page for visitors; authenticated users get their dashboard.
function Home() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <LandingPage />;
  if (!user.is_active) return <Navigate to="/pricing" replace />;
  return <DashboardPage />;
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/pricing" element={<RequireAuth><PricingPage /></RequireAuth>} />
            <Route path="/billing/success" element={<RequireAuth><BillingSuccessPage /></RequireAuth>} />
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
